import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollContributionDetailDTO  {
    _originalTypeClassName = "zERP.BO.PayrollContributionDetailDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollContributionDetailDTO.translate = translateService;
}
this.Id = null;
this.EmployeeContribution = null;
this.EmployeeRate = null;
this.EmployeeAmount = null;
this.EmployeeSubsidy = null;
this.EmployerContribution = null;
this.EmployerRate = null;
this.EmployerAmount = null;
this.EmployerSubsidy = null;
this.APDId = null;
this.APDCode = null;
this.APDCodeName = null;
this.PayrollContributionDetailDTOKey = null;
this._key = this.PayrollContributionDetailDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
EmployeeContribution:any;
EmployeeRate:any;
EmployeeAmount:any;
EmployeeSubsidy:any;
EmployerContribution:any;
EmployerRate:any;
EmployerAmount:any;
EmployerSubsidy:any;
APDId:any;
APDCode:any;
APDCodeName:any;
RuleDTO:any;
private _PayrollContributionDetailDTOKey:any;
get PayrollContributionDetailDTOKey(): any {
    return this._PayrollContributionDetailDTOKey;
  }
set PayrollContributionDetailDTOKey(value: any) {
    this._PayrollContributionDetailDTOKey = value;
    this._key = value;
  }
static setRuleDTO = ($this, value) => {
var oldValue = $this.RuleDTO;
$this.RuleDTO = value;
if (value != null) {
}
}

static Assign(pcd: any): any{let pcdDTO = new Domain.PayrollContributionDetailDTO();
pcdDTO.Id = pcd?.Id;
pcdDTO.EmployeeAmount = pcd?.EmployeeAmount;
pcdDTO.EmployeeContribution = pcd?.EmployeeContribution;
pcdDTO.EmployeeRate = pcd?.EmployeeRate;
pcdDTO.EmployeeSubsidy = pcd?.EmployeeSubsidy;
pcdDTO.EmployerAmount = pcd?.EmployerAmount;
pcdDTO.EmployerContribution = pcd?.EmployerContribution;
pcdDTO.EmployerRate = pcd?.EmployerRate;
pcdDTO.EmployerSubsidy = pcd?.EmployeeSubsidy;
pcdDTO.APDId = pcd?.SalaryType?.Id;
pcdDTO.APDCode = pcd?.SalaryType?.Code;
pcdDTO.APDCodeName = pcd?.SalaryType?.CodeAndName;
Domain.PayrollContributionDetailDTO.setRuleDTO(pcdDTO, Domain.RuleDTO.AssignContribution(pcd?.Rule));
return pcdDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollContributionDetailDTOKey == null || $this.PayrollContributionDetailDTOKey == 0;
            }


}